import moment from "moment";
import ITimeSettingItem from "../interfaces/time-setting-item";

export const mergeDateAndTime = (
  selectedDate: Date,
  selectedTime: string,
): Date => {
  const [hours, minutes] = selectedTime.split(":").map(Number);

  const mergedDate = new Date(selectedDate);
  mergedDate.setHours(hours, minutes, 0, 0);

  return mergedDate;
};

export const isoToTimeSettingItem = (
  isoString?: string | null,
): ITimeSettingItem => {
  if (!isoString) {
    return { hour: "08", minute: "00", period: "AM", enabled: false };
  }
  const m = moment(isoString);
  if (!m.isValid()) {
    return { hour: "08", minute: "00", period: "AM", enabled: false };
  }
  return {
    hour: m.format("hh"),
    minute: m.format("mm"),
    period: m.format("A") as "AM" | "PM",
    enabled: true,
  };
};

export const timeSettingItemToIso = (item: ITimeSettingItem): string | null => {
  if (!item.enabled) {
    return null;
  }
  let h = parseInt(item.hour, 10);
  if (isNaN(h)) h = 12;
  if (item.period === "PM" && h < 12) h += 12;
  if (item.period === "AM" && h === 12) h = 0;

  let m = parseInt(item.minute, 10);
  if (isNaN(m)) m = 0;

  const date = moment().set({
    hour: h,
    minute: m,
    second: 0,
    millisecond: 0,
  });

  return date.toISOString();
};
